export default "__VITE_ASSET__5fa94877__"